export default {
  common: {
    embed_error: 'Ce document doit être ouvert dans un nouvel onglet.',
    no_content: 'Modal content not found',
    close: 'Fermer'
  },
  file_uploader: {
    upload_choose_link: 'Sélectionner',
    upload_documents_html: '%{link} les documents',
    upload_success: 'Téléchargement réussi',
    upload_fail: 'Le téléchargement a échoué',
    upload_too_big: 'Le fichier « {file} » est trop gros pour être téléchargé (Max 20MB).',
    upload_wrong_type: "Le type de document du fichier « {file} » n'est pas supporté.",
    of: 'de'
  },
  zefix: {
    input: "S'il vous plaît entrer au moins trois lettres.",
    error: "Erreur inconnue, s'il vous plaît réessayer plus tard."
  },
  adia_ident: {
    no_connected_advisors: 'Pas de conseillers connectés'
  }
}
